import React, { useContext } from 'react';
import { Row, Col, HeadingText } from '@paypalcorp/pp-react';
import IntegrationPageSectionContext from '../StateManagement/IntegrationPageSectionContext';
import DebouncedTextInput from '../../../components/DebouncedTextInput';
import styles from './VaultSetupTokenConfigurator.module.less';

const OneTimeChargesForm = () => {
  const {
    VaultSetupTokenConfigurator: { oneTimeCharges, updateVaultSetupOption }
  } = useContext(IntegrationPageSectionContext);
  return (
    <>
      <Row className={styles.shipping_form_title_container}>
        <Col xs={11}>
          <HeadingText size="sm">One time charges</HeadingText>
        </Col>
      </Row>
      <Row>
        <Col>
          <DebouncedTextInput
            className={styles.customization_field}
            label="Setup Fee"
            initialValue={oneTimeCharges.setupFee}
            type="number"
            minValue={0}
            onChange={(value) => {
              updateVaultSetupOption(value, 'oneTimeCharges.setupFee');
            }}
          />
        </Col>
        <Col>
          <DebouncedTextInput
            className={styles.customization_field}
            label="Shipping Amount"
            initialValue={oneTimeCharges.shippingAmount}
            type="number"
            minValue={0}
            onChange={(value) => {
              updateVaultSetupOption(value, 'oneTimeCharges.shippingAmount');
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <DebouncedTextInput
            className={styles.customization_field}
            label="Taxes"
            initialValue={oneTimeCharges.taxes}
            type="number"
            minValue={0}
            onChange={(value) => {
              updateVaultSetupOption(value, 'oneTimeCharges.taxes');
            }}
          />
        </Col>
        <Col>
          <DebouncedTextInput
            className={styles.customization_field}
            label="Product Price"
            initialValue={oneTimeCharges.productPrice}
            type="number"
            onChange={(value) => {
              updateVaultSetupOption(value, 'oneTimeCharges.productPrice');
            }}
          />
        </Col>
      </Row>
    </>
  );
};

export default OneTimeChargesForm;
